<template>
  <v-container>
    <h1 class="text-center">PURCHASE DETIALS</h1>
    <div>
      <v-form ref="form">
        <v-container>
          <template>
            <v-row>
              <v-col>
                <v-text-field
                  label="INVOICE NUMBER"
                  required
                  prepend-icon="mdi-receipt"
                  v-model="invoiceNumber"
                  :rules="[RULES.required]"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  color="primary1"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="indate"
                      label="Purchase Date"
                      prepend-icon="mdi-calendar-check"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="indate" @input="menu = false" color="primary1"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <span class="red--text">*leave both the column blank if there is no stock</span>
            <v-simple-table height="300px">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">ITEM NAME</th>
                    <th class="text-left">CATEGORY</th>
                    <th class="text-left">MRP</th>
                    <th class="text-left">STOCK</th>
                    <th class="text-left">BOUGHT</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in VENDOR_PRODUCTS" :key="index">
                    <td>{{ item.name }}</td>
                    <td>{{ item.category }}</td>
                    <td>
                      <v-text-field label="MRP  ₹" required v-model="item.newStockRate"></v-text-field>
                    </td>
                    <td>
                      <v-text-field label="Qty" required v-model="item.newStock"></v-text-field>
                    </td>
                    <td>
                      <v-text-field
                        label="BOUGHT RATE TOTAL ₹"
                        required
                        v-model="item.bought_rate"
                        @blur="calcTotal"
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
          <v-text-field
            label="INVOICE TOTAL ₹"
            required
            v-model="invoiceRate"
            :rules="[RULES.required, RULES.mrp]"
          ></v-text-field>
        </v-container>
      </v-form>
      <v-btn color="primary1" block dark @click="newStockAdd">ADD</v-btn>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      invoiceNumber: "",
      invoiceRate: "",
      indate: "",
      selDate: "",
      menu: false,
    };
  },
  created() {
    this.$store.commit("SET_LOADING", true);
    this.GET_PRODUCT_LIST({ id: this.$route.params.id }).then(() => {
      this.$store.commit("SET_LOADING", false);
    });
  },
  computed: {
    ...mapGetters(["RULES", "VENDOR_PRODUCTS", "STOCKROOM"]),
  },
  methods: {
    ...mapActions(["GET_PRODUCT_LIST", "ADD_NEW_STOCK"]),
    newStockAdd() {
      if (this.invoiceNumber != "" && this.indate != "") {
        this.calcTotal();
        let prodList = [];
        this.VENDOR_PRODUCTS.forEach((el) => {
          if (
            el.newStockRate != "" &&
            el.newStockRate != undefined &&
            el.newStock != "" &&
            el.newStock != undefined &&
            el.bought_rate != "" &&
            el.bought_rate != undefined
          ) {
            prodList.push({
              pid: el.id,
              mrp: el.newStockRate,
              stock: el.newStock,
              rate: el.newStockRate,
              bought_rate: el.bought_rate,
            });
          }
        });
        let invoice = {
          no: this.invoiceNumber,
          rate: this.invoiceRate,
          date: this.indate,
          vendor: this.$route.params.id,
        };
        if (prodList.length >= 1 && this.invoiceRate >= 1) {
          this.$store.commit("SET_LOADING", true);
          this.ADD_NEW_STOCK({
            prodList,
            invoice,
          }).then(() => {
            this.newStock = false;
            this.tab1 = true;
            this.tab2 = false;
            this.invoiceNumber = "";
            this.indate = "";
            this.invoiceRate = 0;
            this.$store.commit("SET_LOADING", false);
          });
        } else {
          this.$store.commit("SET_INFO", "No Stock Added");
        }
      } else {
        this.$store.commit("SET_INFO", "Fill all Data");
      }
    },
    calcTotal() {
      let sum = 0;
      this.VENDOR_PRODUCTS.forEach((el) => {
        if (el.bought_rate != "" && el.bought_rate != undefined) {
          sum = Number(sum) + Number(el.bought_rate);
        }
      });
      this.invoiceRate = sum;
    },
  },
  watch: {},
};
</script>

<style>
</style>